import * as React from 'react';
import {useEffect, useState, useCallback} from 'react';
import {ISubmissionProps} from '../utils/models';
import {getSurveySubmissions} from '../utils/submissions';
import Loader from '../../../shared/Loader';
import NonFoodIn from '../NonFoodIn';
import NonFoodOut from '../NonFoodOut';

const NonFoodInNonFoodOut = ({
    container,
    selectedUoa,
    selectedYear,
    survey,
}: ISubmissionProps) => {
    const [loading, setLoading] = useState(true);
    const [submissions, setSubmissions] = useState([]);

    const getSurveysData = useCallback(async () => {
        setLoading(true);

        if (survey) {
            const data = await getSurveySubmissions({
                container,
                survey_id: survey,
                selectedUoa,
                selectedYear,
            });
            setSubmissions(data);
        }
    }, [container, survey, selectedUoa, selectedYear]);

    useEffect(() => {
        getSurveysData().then(() => setLoading(false));
    }, [getSurveysData]);

    return (
        <>
            {!loading && (
                <>
                    <NonFoodIn submissions={submissions} />
                    <NonFoodOut submissions={submissions} />
                </>
            )}
            {loading && (
                <div className='loader-container col-span-2'>
                    <Loader size={60} />
                </div>
            )}
        </>
    );
};

export default NonFoodInNonFoodOut;
